export const COURSE_STEP_STATUS = Object.freeze({
  LOCKED: 1,
  AVAILABLE: 2,
  IN_PROGRESS: 3,
  COMPLETED: 4,
  ACTION_REQUIRED: 5,
});
